import React from "react"
import { graphql } from "gatsby"

import { TagButton } from "../components/TagButton"
import { Layout } from "../components/Layout"
import { SEO } from "../components/Seo"

interface TagGroup {
    fieldValue: string;
    totalCount: number;
}

interface TagsPageProps {
    data: {
        allMarkdownRemark: {
            group: TagGroup[]
        }
    }
}

const TagsPage = ({
    data: {
        allMarkdownRemark: { group }
    }
}: TagsPageProps) => (
    <Layout>
        <SEO title='All Tags' />
        <h1>All Tags</h1>
        <ul className='button-container'>
            {group.map((tag) => (
                <TagButton
                    key={tag.fieldValue}
                    text={`${tag.fieldValue} (${tag.totalCount})`}
                />
            ))}
        </ul>
    </Layout>
)

export default TagsPage

export const pageQuery = graphql`
    query TagsQuery {
        allMarkdownRemark(
            limit: 100
        ) {
            group(field: frontmatter___tags) {
                fieldValue
                totalCount
            }
        }
    }
`
